import { isValidElementType } from 'react-is';

import callbackToEvent from './callbackToEvent';
import componentMap from './componentsMap';

const createInventory = () => {
  const map = new Map(
    Object.entries(componentMap)
      .filter(
        ([, component]) =>
          typeof component !== 'string' && isValidElementType(component)
      )
      .map(([type, component]) => [
        type,
        {
          component,
          callbacks: callbackToEvent[type] || {},
        },
      ])
  );
  return {
    get(type) {
      return map.get(type);
    },
    has(type) {
      return map.has(type);
    },
  };
};

export default createInventory;
